import { render, staticRenderFns } from "./forms.html?vue&type=template&id=0a4af38a&scoped=true&external"
import script from "./Forms.vue?vue&type=script&lang=js"
export * from "./Forms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4af38a",
  null
  
)

export default component.exports